var _defs, _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSopadeletras(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4d02e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa60f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hi",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ffffff",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 143,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 143,
    fill: "url(#hi)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.3,97.3) scale(13.2267)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 4.6,
    height: 4.6,
    rx: 1.2,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 4.6,
    height: 4.6,
    rx: 1.2,
    fill: "rgba(255,255,255,0.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 16,
    width: 4.6,
    height: 4.6,
    rx: 1.2,
    fill: "rgba(255,255,255,0.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 4.6,
    height: 4.6,
    rx: 1.2,
    fill: "rgba(255,255,255,0.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 4.6,
    height: 4.6,
    rx: 1.2,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16,
    width: 4.6,
    height: 4.6,
    rx: 1.2,
    fill: "rgba(255,255,255,0.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 4,
    width: 4.6,
    height: 4.6,
    rx: 1.2,
    fill: "rgba(255,255,255,0.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10,
    width: 4.6,
    height: 4.6,
    rx: 1.2,
    fill: "rgba(255,255,255,0.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 4.6,
    height: 4.6,
    rx: 1.2,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3 6.3L17.7 17.7",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSopadeletras);
export default __webpack_public_path__ + "static/media/sopadeletras.25f7faea2358a49b993dbb71f650dd1a.svg";
export { ForwardRef as ReactComponent };